module.exports = __webpack_public_path__ + "img/santa-catalina.69e0a3c6.jpg";